import React from 'react';
import PropTypes from 'prop-types';
import './EmptyState.css';

/**
 * EmptyState Component
 * Displays an empty state message with optional icon and action button
 *
 * @param {string|node} icon - Icon to display (emoji, SVG, or component)
 * @param {string} title - Main heading text
 * @param {string} description - Supporting description text
 * @param {string} actionLabel - Label for action button (optional)
 * @param {Function} onAction - Callback when action button is clicked (optional)
 * @param {node} children - Custom content to display (optional)
 */
const EmptyState = ({
  icon,
  title,
  description,
  actionLabel,
  onAction,
  children,
}) => {
  return (
    <div className="empty-state">
      <div className="empty-state__content">
        {title && <h3 className="empty-state__title">{title}</h3>}
        {description && <p className="empty-state__description">{description}</p>}
        {children && <div className="empty-state__custom">{children}</div>}
        {actionLabel && onAction && (
          <button className="btn linear-gradient zy-save-btn ml-2" onClick={onAction}>
            {actionLabel}
          </button>
        )}
      </div>
    </div>
  );
};

EmptyState.propTypes = {
  icon: PropTypes.node,
  title: PropTypes.string,
  description: PropTypes.string,
  actionLabel: PropTypes.string,
  onAction: PropTypes.func,
  children: PropTypes.node,
};

export default EmptyState;
